import React from 'react';

function Users(props: object) {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.6394 13.0013C2.13884 12.2334 2.82215 11.6024 3.62732 11.1656C4.43249 10.7288 5.33401 10.5 6.25003 10.5C7.16605 10.5 8.06757 10.7288 8.87274 11.1656C9.67791 11.6024 10.3612 12.2334 10.8607 13.0013"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.75 10.5C12.666 10.4995 13.5676 10.7279 14.3728 11.1645C15.178 11.6011 15.8613 12.2321 16.3606 13"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.25 10.5C8.04493 10.5 9.5 9.04493 9.5 7.25C9.5 5.45507 8.04493 4 6.25 4C4.45507 4 3 5.45507 3 7.25C3 9.04493 4.45507 10.5 6.25 10.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5432 4.23125C10.9878 4.05393 11.466 3.977 11.9438 4.00595C12.4215 4.0349 12.887 4.16901 13.3069 4.39871C13.7268 4.6284 14.0908 4.94801 14.3729 5.33469C14.655 5.72138 14.8481 6.16559 14.9386 6.63559C15.0291 7.10558 15.0147 7.58977 14.8963 8.05353C14.778 8.5173 14.5587 8.94921 14.2541 9.31839C13.9494 9.68758 13.5671 9.98492 13.1342 10.1892C12.7013 10.3934 12.2287 10.4996 11.7501 10.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Users;
